var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessplans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#ADF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 21.25H31V20.5C30.9993 19.9035 30.7621 19.3315 30.3403 18.9097C29.9185 18.4879 29.3465 18.2507 28.75 18.25H27.25C26.6535 18.2507 26.0815 18.4879 25.6597 18.9097C25.2379 19.3315 25.0007 19.9035 25 20.5V21.25H20.5C19.9035 21.2507 19.3315 21.4879 18.9097 21.9097C18.4879 22.3315 18.2507 22.9035 18.25 23.5V27.25H37.75V23.5C37.7493 22.9035 37.5121 22.3315 37.0903 21.9097C36.6685 21.4879 36.0965 21.2507 35.5 21.25ZM26.5 20.5C26.5003 20.3012 26.5794 20.1106 26.72 19.97C26.8606 19.8294 27.0512 19.7503 27.25 19.75H28.75C28.9489 19.7502 29.1395 19.8293 29.2801 19.9699C29.4207 20.1105 29.4998 20.3011 29.5 20.5V21.25H26.5V20.5ZM28.75 28.75V29.5H27.25V28.75H28.75ZM30.25 28.75H37.75V33.25C37.7493 33.8465 37.5121 34.4185 37.0903 34.8403C36.6685 35.2621 36.0965 35.4993 35.5 35.5H20.5C19.9035 35.4993 19.3315 35.2621 18.9097 34.8403C18.4879 34.4185 18.2507 33.8465 18.25 33.25V28.75H25.75V30.25C25.75 30.4489 25.829 30.6397 25.9697 30.7803C26.1103 30.921 26.3011 31 26.5 31H29.5C29.6989 31 29.8897 30.921 30.0303 30.7803C30.171 30.6397 30.25 30.4489 30.25 30.25V28.75Z",
    fill: "#00A4B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessplans);
export default __webpack_public_path__ + "static/media/businessplans.898606449ea78d3e142127ade940417a.svg";
export { ForwardRef as ReactComponent };